"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DictionarySpec = void 0;
// MIT © 2017 azu
var ddd_base_1 = require("ddd-base");
var DictionarySpec = /** @class */ (function (_super) {
    __extends(DictionarySpec, _super);
    function DictionarySpec(props) {
        var _this = _super.call(this, props) || this;
        _this.from = props.from;
        _this.to = props.to;
        return _this;
    }
    Object.defineProperty(DictionarySpec.prototype, "isInvalid", {
        get: function () {
            return this.error !== undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DictionarySpec.prototype, "isFilled", {
        get: function () {
            if (!this.from) {
                return false;
            }
            if (!this.to) {
                return false;
            }
            return true;
        },
        enumerable: false,
        configurable: true
    });
    DictionarySpec.prototype.updateExpected = function (expected) {
        return new DictionarySpec(__assign(__assign({}, this), { to: expected }));
    };
    DictionarySpec.prototype.invalid = function (error) {
        return new DictionarySpec(__assign(__assign({}, this), { error: error }));
    };
    return DictionarySpec;
}(ddd_base_1.ValueObject));
exports.DictionarySpec = DictionarySpec;
//# sourceMappingURL=DictionarySpec.js.map


//////////////////
// WEBPACK FOOTER
// ../domain/lib/Dictionary/DictionarySpec.js
// module id = 421
// module chunks = 0